// extracted by mini-css-extract-plugin
export default {"cls1":"uAvZGjqNnBZ9gqoQ1zR4","cls2":"Nd5x0fdPpM0ARQS3TGwW uAvZGjqNnBZ9gqoQ1zR4"};